import React from "react";

import Mainpart from "./components/Mainpart";
export default function App() {
  return (
    <div>
    <Mainpart></Mainpart>
    </div>
  );
}
